import React, { useEffect, useState } from "react";
import Input from "../../../Common/Components/Input";
import styled from "styled-components";
import SearchTerm from "../../../Content/Search/Components/SearchTerm";
import { useSelector } from "react-redux";
import store, { RootState } from "store";
type Props = {
  inputId?: string;
  heading: String;
  subText?: String;
  placeholder: String;
  desc: String;
  searchTerms?: Array<string>;
  handleAddSearchTerm?: any;
  handleOnRemove?: any;
  showInput?: boolean;
  isPeople?: boolean;
  desClassName?: string;
  onFocus?: any;
  onBlur?: any;
};

const KeywordSource: React.FC<Props> = ({
  inputId,
  children,
  heading,
  subText,
  placeholder,
  desc,
  searchTerms,
  handleAddSearchTerm,
  handleOnRemove,
  showInput = true,
  isPeople = false,
  desClassName,
  onFocus,
  onBlur,
}) => {
  const [value, setValue] = useState("");
  const showCreateCampaignAsider = useSelector((store: RootState) => store.uiReducer.showCreateCampaignAsider);

  useEffect(() => {
    if (showCreateCampaignAsider === false) setValue("");
  }, [showCreateCampaignAsider]);

  return (
    <Wrapper>
      <div className="add-words-wrapper">
        <div className="wrapper-content">
          <div className="wrapper">
            <h3 className="add-word-head">{heading}</h3>
            {subText && <span className="sub-text">({subText})</span>}
          </div>
          {children}
        </div>
        {searchTerms ? (
          <div className="wrapper-content mt-1" style={{ maxWidth: "100%" }}>
            {searchTerms.length > 0 ? (
              <div className="keyword-wrapper" style={{ marginBottom: "5px", maxWidth: "100%" }}>
                {searchTerms.map((keyword, index) => (
                  <SearchTerm
                    key={index}
                    searchTerm={keyword}
                    searchTermId={keyword}
                    onRemove={handleOnRemove}
                    isToolTip={true}
                  />
                ))}
              </div>
            ) : null}
          </div>
        ) : null}
        {showInput === true ? (
          <Input
            {...(inputId ? { id: inputId } : {})}
            {...(onFocus ? { onFocus } : {})}
            {...(onBlur ? { onBlur } : {})}
            type="text"
            value={value}
            className="search-input"
            placeholder={placeholder}
            onChange={(e: any) => (e.target.value !== "," ? setValue(e.target.value) : null)}
            onKeyPress={(e: any) => {
              if ((e.key === "Enter" || e.key === ",") && handleAddSearchTerm) {
                let searchText = value;
                const currentSearchTerms = searchText
                  .trim()
                  .split(",")
                  .filter((r) => r !== "")
                  .join("");
                if (currentSearchTerms) handleAddSearchTerm(currentSearchTerms);
                setValue("");
              }
            }}
          />
        ) : null}
        {desc ? <p className={`dec-paragraph mb ${desClassName}`}>{desc}</p> : null}
      </div>
    </Wrapper>
  );
};

export default KeywordSource;

const Wrapper = styled.div`
  .add-words-wrapper {
    .wrapper-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0px 3px;
      .add-word-head {
        color: #5e7079;
        font-size: 20px;
        margin-bottom: 0px;
        font-family: "Roboto", sans-serif;
        font-weight: 600;
        display: inline-block;
        letter-spacing: -0.6px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 14px;
        }
      }
      .sub-text {
        font-size: 14px;
        margin-left: 3px;
        font-weight: 600;
        opacity: 0.4;
        color: rgba(0, 0, 0, 0.85);
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 10px;
        }
      }
      .test {
        font-weight: bold;
        font-size: 12px;
        color: #27ce0a;
        border: 1px solid #27ce0a;
        padding: 2px 8px;
        border-radius: 6px;
        cursor: pointer;
        letter-spacing: 1px;
        width: auto;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 9px;
          border-radius: 4px;
        }
        &.active {
          color: #fff;
          border: 1px solid #27ce0a;
          background-color: #27ce0a;
        }
      }
    }
    .search-input {
      /* padding: 10px 18px;
      font-size: 16px;
      line-height: 20px;
      height: 38px; */
      width: 99%;
      margin-left: 3px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 12px;
        line-height: 16px;
        padding: 7px 10px;
        border-radius: 6px;
      }
    }
    .dec-paragraph {
      color: #5e7079;
      font-size: 14px;
      margin-bottom: 0px;
      font-family: "robotoregular";
      font-weight: 600;
      margin-top: 10px;
      opacity: 0.6;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 10px;
      }
      &.mb {
        margin-bottom: 80px;
        @media (max-width: 1439px) {
          margin-bottom: 40px;
        }
      }
      &.mb-s {
        margin-bottom: 20px !important;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          margin-bottom: 10px !important;
        }
      }
    }
  }
`;
